export default "__VITE_ASSET__D8guleg3__"